import React, { ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  handleClose: () => void;
  children: ReactNode | null;
  extraFooterButtons?: ReactNode | null;
  cancelText?: string;
}
export const Modal: React.FC<ModalProps> = ({ isOpen, handleClose, children, extraFooterButtons, cancelText }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={handleClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: 15,
          maxWidth: '600px',
          width: '90%',
          boxShadow: '0 20px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        {children}
        <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: 8 }}>
          <button
            onClick={handleClose}
            style={{
              padding: '8px 16px',
              // backgroundColor: '#F62F2F',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              marginTop: 8,
            }}
          >
            {cancelText || 'Close'}
          </button>
          {extraFooterButtons}
        </div>

      </div>
    </div>
  );
};
